// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:03 GMT

export const medicine_delivery_tailwind_config = {
  fontFamily: {
    "title-lg1_1-fontFamily": "Circular Std, sans-serif",
    "title-lg1_2-fontFamily": "Gilroy-Medium, sans-serif",
    "title-lg1_3-fontFamily": "Circular Std, sans-serif",
    "title-lg1_4-fontFamily": "Circular Std, sans-serif",
    "title-lg1_5-fontFamily": "Circular Std, sans-serif",
    "title-lg2_1-fontFamily": "Circular Std, sans-serif",
    "title-lg2_2-fontFamily": "Circular Std, sans-serif",
    "title-lg3_1-fontFamily": "Circular Std, sans-serif",
    "title-lg3_2-fontFamily": "Circular Std, sans-serif",
    "title-lg4_1-fontFamily": "Gilroy-Bold, sans-serif",
    "title-lg5_1-fontFamily": "Circular Std, sans-serif",
    "title-md1_1-fontFamily": "Circular Std, sans-serif",
    "title-md1_2-fontFamily": "Circular Std, sans-serif",
    "title-md1_3-fontFamily": "Circular Std, sans-serif",
    "title-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md1_1-fontFamily": "Circular Std, sans-serif",
    "body-md1_8-fontFamily": "Circular Std, sans-serif",
    "body-md1_2-fontFamily": "Circular Std, sans-serif",
    "body-md1_3-fontFamily": "Circular Std, sans-serif",
    "body-md1_4-fontFamily": "Circular Std, sans-serif",
    "body-md1_5-fontFamily": "Circular Std, sans-serif",
    "body-md1_6-fontFamily": "Circular Std, sans-serif",
    "body-md1_7-fontFamily": "Circular Std, sans-serif",
    "body-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_2-fontFamily": "Circular Std, sans-serif",
    "body-md3_3-fontFamily": "Circular Std, sans-serif",
    "body-md3_4-fontFamily": "Circular Std, sans-serif",
    "body-md3_5-fontFamily": "Circular Std, sans-serif",
    "body-md3_6-fontFamily": "Circular Std, sans-serif",
    "body-md3_7-fontFamily": "Circular Std, sans-serif",
    "body-sm1_1-fontFamily": "Circular Std, sans-serif",
    "body-sm2_1-fontFamily": "Circular Std, sans-serif",
    "body-lg1_1-fontFamily": "Circular Std, sans-serif",
    "body-lg1_2-fontFamily": "Circular Std, sans-serif",
    "discount-sm1_1-fontFamily": "Circular Std, sans-serif",
    "discount-sm1_2-fontFamily": "Circular Std, sans-serif",
    "cta-typo-1-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-2-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-3-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-4-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-5-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-6-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-7-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-8-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-9-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-10-fontFamilies": "Circular Std, sans-serif",
  },
  fontWeight: {
    "title-lg1_1-fontWeight": 500,
    "title-lg1_3-fontWeight": 400,
    "title-lg1_4-fontWeight": 400,
    "title-lg1_5-fontWeight": 700,
    "title-lg2_1-fontWeight": 700,
    "title-lg2_2-fontWeight": 500,
    "title-lg3_1-fontWeight": 500,
    "title-lg3_2-fontWeight": 700,
    "title-lg5_1-fontWeight": 700,
    "title-md1_1-fontWeight": 400,
    "title-md1_2-fontWeight": 700,
    "title-md1_3-fontWeight": 500,
    "title-md2_1-fontWeight": 500,
    "body-md1_1-fontWeight": 400,
    "body-md1_8-fontWeight": 400,
    "body-md1_2-fontWeight": 400,
    "body-md1_3-fontWeight": 500,
    "body-md1_4-fontWeight": 300,
    "body-md1_5-fontWeight": 300,
    "body-md1_6-fontWeight": 400,
    "body-md1_7-fontWeight": 700,
    "body-md2_1-fontWeight": 400,
    "body-md3_1-fontWeight": 700,
    "body-md3_2-fontWeight": 300,
    "body-md3_3-fontWeight": 300,
    "body-md3_4-fontWeight": 400,
    "body-md3_5-fontWeight": 700,
    "body-md3_6-fontWeight": 500,
    "body-md3_7-fontWeight": 400,
    "body-sm1_1-fontWeight": 300,
    "body-sm2_1-fontWeight": 500,
    "body-lg1_1-fontWeight": 500,
    "body-lg1_2-fontWeight": 700,
    "discount-sm1_1-fontWeight": 500,
    "discount-sm1_2-fontWeight": 400,
    "cta-typo-1-fontWeights": 700,
    "cta-typo-2-fontWeights": 400,
    "cta-typo-3-fontWeights": 400,
    "cta-typo-4-fontWeights": 500,
    "cta-typo-5-fontWeights": 500,
    "cta-typo-6-fontWeights": 400,
    "cta-typo-7-fontWeights": 300,
    "cta-typo-8-fontWeights": 500,
    "cta-typo-9-fontWeights": 400,
    "cta-typo-10-fontWeights": 300,
  },
  lineHeight: {
    "title-lg1_1-lineHeight": "inherit",
    "title-lg1_2-lineHeight": "inherit",
    "title-lg1_3-lineHeight": "inherit",
    "title-lg1_4-lineHeight": "inherit",
    "title-lg1_5-lineHeight": "inherit",
    "title-lg2_1-lineHeight": "inherit",
    "title-lg2_2-lineHeight": "inherit",
    "title-lg3_1-lineHeight": "inherit",
    "title-lg3_2-lineHeight": "inherit",
    "title-lg4_1-lineHeight": "inherit",
    "title-lg5_1-lineHeight": "inherit",
    "title-md1_1-lineHeight": "inherit",
    "title-md1_2-lineHeight": "inherit",
    "title-md1_3-lineHeight": "inherit",
    "title-md2_1-lineHeight": "inherit",
    "body-md1_1-lineHeight": "inherit",
    "body-md1_8-lineHeight": "inherit",
    "body-md1_2-lineHeight": "inherit",
    "body-md1_3-lineHeight": "inherit",
    "body-md1_4-lineHeight": "inherit",
    "body-md1_5-lineHeight": "inherit",
    "body-md1_6-lineHeight": "inherit",
    "body-md1_7-lineHeight": "inherit",
    "body-md2_1-lineHeight": "inherit",
    "body-md3_1-lineHeight": "inherit",
    "body-md3_2-lineHeight": "inherit",
    "body-md3_3-lineHeight": "inherit",
    "body-md3_4-lineHeight": "inherit",
    "body-md3_5-lineHeight": "inherit",
    "body-md3_6-lineHeight": "inherit",
    "body-md3_7-lineHeight": "inherit",
    "body-sm1_1-lineHeight": "inherit",
    "body-sm2_1-lineHeight": "inherit",
    "body-lg1_1-lineHeight": "inherit",
    "body-lg1_2-lineHeight": "inherit",
    "discount-sm1_1-lineHeight": "inherit",
    "discount-sm1_2-lineHeight": "inherit",
    "cta-typo-1-lineHeights": "inherit",
    "cta-typo-2-lineHeights": "inherit",
    "cta-typo-3-lineHeights": "inherit",
    "cta-typo-6-lineHeights": "inherit",
    "cta-typo-7-lineHeights": "inherit",
    "cta-typo-10-lineHeights": "inherit",
  },
  fontSize: {
    "title-lg1_1-fontSize": "1rem",
    "title-lg1_2-fontSize": "1rem",
    "title-lg1_3-fontSize": "1rem",
    "title-lg1_4-fontSize": "1rem",
    "title-lg1_5-fontSize": "1rem",
    "title-lg2_1-fontSize": "1.125rem",
    "title-lg2_2-fontSize": "1.125rem",
    "title-lg3_1-fontSize": "1.25rem",
    "title-lg3_2-fontSize": "1.25rem",
    "title-lg4_1-fontSize": "2rem",
    "title-lg5_1-fontSize": "1.5rem",
    "title-md1_1-fontSize": "0.75rem",
    "title-md1_2-fontSize": "0.75rem",
    "title-md1_3-fontSize": "0.75rem",
    "title-md2_1-fontSize": "0.875rem",
    "body-md1_1-fontSize": "0.75rem",
    "body-md1_8-fontSize": "0.75rem",
    "body-md1_2-fontSize": "0.75rem",
    "body-md1_3-fontSize": "0.75rem",
    "body-md1_4-fontSize": "0.75rem",
    "body-md1_5-fontSize": "0.75rem",
    "body-md1_6-fontSize": "0.75rem",
    "body-md1_7-fontSize": "0.75rem",
    "body-md2_1-fontSize": "0.8125rem",
    "body-md3_1-fontSize": "0.875rem",
    "body-md3_2-fontSize": "0.875rem",
    "body-md3_3-fontSize": "0.875rem",
    "body-md3_4-fontSize": "0.875rem",
    "body-md3_5-fontSize": "0.875rem",
    "body-md3_6-fontSize": "0.875rem",
    "body-md3_7-fontSize": "0.875rem",
    "body-sm1_1-fontSize": "0.5rem",
    "body-sm2_1-fontSize": "0.625rem",
    "body-lg1_1-fontSize": "1.25rem",
    "body-lg1_2-fontSize": "1.25rem",
    "discount-sm1_1-fontSize": "0.5rem",
    "discount-sm1_2-fontSize": "0.75rem",
    "cta-typo-1-fontSizes": "0.875rem",
    "cta-typo-2-fontSizes": "0.75rem",
    "cta-typo-3-fontSizes": "0.75rem",
    "cta-typo-4-fontSizes": "1rem",
    "cta-typo-5-fontSizes": "0.625rem",
    "cta-typo-6-fontSizes": "0.75rem",
    "cta-typo-7-fontSizes": "0.875rem",
    "cta-typo-8-fontSizes": "0.875rem",
    "cta-typo-9-fontSizes": "0.875rem",
    "cta-typo-10-fontSizes": "0.875rem",
  },
  letterSpacing: {
    "title-lg1_1-letterSpacing": "0rem",
    "title-lg1_2-letterSpacing": "0rem",
    "title-lg1_3-letterSpacing": "0rem",
    "title-lg1_4-letterSpacing": "0.02rem",
    "title-lg1_5-letterSpacing": "0rem",
    "title-lg2_1-letterSpacing": "0rem",
    "title-lg2_2-letterSpacing": "0rem",
    "title-lg3_1-letterSpacing": "0rem",
    "title-lg3_2-letterSpacing": "0rem",
    "title-lg4_1-letterSpacing": "0rem",
    "title-lg5_1-letterSpacing": "0rem",
    "title-md1_1-letterSpacing": "0rem",
    "title-md1_2-letterSpacing": "0rem",
    "title-md1_3-letterSpacing": "0rem",
    "title-md2_1-letterSpacing": "0rem",
    "body-md1_1-letterSpacing": "0rem",
    "body-md1_8-letterSpacing": "0rem",
    "body-md1_2-letterSpacing": "0.01rem",
    "body-md1_3-letterSpacing": "0rem",
    "body-md1_4-letterSpacing": "0rem",
    "body-md1_5-letterSpacing": "0.03rem",
    "body-md1_6-letterSpacing": "0rem",
    "body-md1_7-letterSpacing": "0rem",
    "body-md2_1-letterSpacing": "0rem",
    "body-md3_1-letterSpacing": "0.03rem",
    "body-md3_2-letterSpacing": "0rem",
    "body-md3_3-letterSpacing": "0rem",
    "body-md3_4-letterSpacing": "0.02rem",
    "body-md3_5-letterSpacing": "0rem",
    "body-md3_6-letterSpacing": "0rem",
    "body-md3_7-letterSpacing": "0rem",
    "body-sm1_1-letterSpacing": "0rem",
    "body-sm2_1-letterSpacing": "0rem",
    "body-lg1_1-letterSpacing": "0rem",
    "body-lg1_2-letterSpacing": "0rem",
    "discount-sm1_1-letterSpacing": "0rem",
    "discount-sm1_2-letterSpacing": "0rem",
    "cta-typo-1-letterSpacing": "0.03rem",
    "cta-typo-2-letterSpacing": "0rem",
    "cta-typo-3-letterSpacing": "0rem",
    "cta-typo-4-letterSpacing": "0rem",
    "cta-typo-5-letterSpacing": "0rem",
    "cta-typo-6-letterSpacing": "0rem",
    "cta-typo-7-letterSpacing": "0rem",
    "cta-typo-8-letterSpacing": "0rem",
    "cta-typo-9-letterSpacing": "0rem",
    "cta-typo-10-letterSpacing": "0rem",
  },
  colors: {
    "on-bg-7": "#121212",
    "on-bg-10": "#191919",
    "on-bg-12": "#202020",
    "on-bg-15": "#262626",
    "on-bg-20": "#333333",
    "on-bg-25": "#404040",
    "on-bg-30": "#4C4C4C",
    "on-bg-35": "#595959",
    "on-bg-40": "#666666",
    "on-bg-45": "#737373",
    "on-bg-55": "#8C8C8C",
    "on-bg-60": "#999999",
    "on-bg-65": "#A6A6A6",
    "on-bg-70": "#B2B2B2",
    "on-bg-80": "#CCCCCC",
    "on-bg-85": "#D9D9D9",
    "on-bg-90": "#E5E5E5",
    "on-bg-95": "#F2F2F2",
    "on-bg-100": "#FFFFFF",
    "secondary-60": "#38774D",
    "secondary-70": "#418B5A",
    "secondary-80": "#4A9F66",
    "secondary-100": "#5DC780",
    "secondary-120": "#7DD299",
    "secondary-170": "#CEEED9",
    "secondary-custom1": "#5E8F6E",
    "primary-100": "#4364EF",
    "primary-120": "#6983F2",
    "primary-130": "#7B93F4",
    "primary-150": "#A1B1F7",
    "primary-160": "#B4C1F9",
    "tertiary-100": "#EEAB5E",
    "error-100": "#D45858",
    "cta-entry-field-1-borderColor": "#262626",
    "cta-entry-field-1-fill": "#191919",
    "cta-entry-field-2-borderColor": "#262626",
    "cta-entry-field-2-fill": "#191919",
    "cta-button-1-fill": "#262D4C",
    "cta-button-2-fill": "#202020",
    "cta-button-3-fill": "#3929F2",
    "cta-button-4-fill": "#3929F2",
    "cta-button-5-fill": "#191919",
    "cta-button-5-borderColor": "#262626",
    "cta-button-6-fill": "#999999",
    "cta-button-7-fill": "#3929F2",
    "cta-button-8-fill": "#E5E5E5",
    "cta-button-9-fill": "#418B5A",
    "cta-button-10-fill": "#E5E5E5",
    "cta-button-11-fill": "#191919",
    "cta-button-12-fill": "#999999",
    "cta-button-13-fill": "#3929F2",
    "cta-button-14-fill": "#D9E0FC",
    "cta-contact-1-fill": "#191919",
    "cta-contact-1-borderColor": "#262626",
    "cta-frame-1-fill": "#4A9F66",
    "cta-frame-2-fill": "#121212",
    "cta-frame-3-fill": "#3F4A80",
    "cta-frame-4-fill": "#4C4C4C",
    "cta-checkbox-1-fill": "#5DC780",
    "cta-hamburger-1-fill": "#191919",
    "cta-hamburger-1-borderColor": "#262626",
    "cta-hamburger-2-fill": "#191919",
    "cta-hamburger-2-borderColor": "#262626",
    "cta-hamburger-3-fill": "#191919",
    "cta-hamburger-3-borderColor": "#262626",
    "frame-upload-prescription-1-fill": "#121212",
    "frame-listing-1-borderColor": "#262626",
    "frame-listing-1-fill": "#191919",
    "frame-categories-1-fill": "#A1B1F7",
    "frame-categories-2-fill": "#4A9F66",
    "frame-categories-3-fill": "#EEAB5E",
    "frame-categories-4-fill": "#DB7B94",
    "frame-categories-5-fill": "#5DC780",
    "frame-categories-6-fill": "#EEAB5E",
    "frame-categories-7-fill": "#BB94C1",
    "frame-categories-8-fill": "#675541",
    "frame-entryfield-1-borderColor": "#262626",
    "frame-entryfield-1-fill": "#191919",
    "frame-entryfield-2-fill": "#262626",
    "frame-entryfield-3-fill": "#262626",
    "frame-entryfield-4-fill": "#262626",
    "frame-entryfield-5-fill": "#191919",
    "frame-entryfield-5-borderColor": "#333333",
    "frame-dropdown-1-fill": "#191919",
    "frame-dropdown-2-fill": "#191919",
    "frame-dropdown-2-borderColor": "#262626",
    "frame-dropdown-3-fill": "#191919",
    "frame-dropdown-3-borderColor": "#262626",
    "frame-dropdown-4-fill": "#121212",
    "frame-dropdown-4-borderColor": "#202020",
    "frame-dropdown-5-fill": "#191919",
    "frame-dropdown-5-borderColor": "#262626",
    "frame-chat-1-fill": "#121212",
    "frame-chat-1-borderColor": "#202020",
    "frame-chat-2-fill": "#202020",
    "frame-chat-3-fill": "#333333",
    "frame-chat-4-fill": "#333333",
    "frame-chat-4-borderColor": "#4C4C4C",
    "frame-chat-5-fill": "#FFFFFF",
    "frame-chat-7-fill": "#333333",
    "frame-chat-7-borderColor": "#4C4C4C",
    "frame-chat-8-fill": "#202020",
    "frame-chat-9-fill": "#404040",
    "frame-chat-9-borderColor": "#595959",
    "frame-payment-1-fill": "#121212",
    "frame-payment-2-fill": "#121212",
    "frame-payment-3-fill": "#121212",
    "frame-payment-3-borderColor": "#262626",
    "frame-payment-4-borderColor": "#262626",
    "frame-payment-4-fill": "#121212",
    "frame-payment-5-fill": "#121212",
    "frame-payment-6-fill": "#121212",
    "frame-payment-7-borderColor": "#333333",
    "frame-payment-7-fill": "#121212",
    "frame-payment-8-borderColor": "#333333",
    "frame-payment-8-fill": "#121212",
    "frame-payment-9-borderColor": "#333333",
    "frame-payment-9-fill": "#121212",
    "frame-tracking-1-fill": "#121212",
    "frame-tracking-1-borderColor": "#202020",
    "frame-tracking-2-fill": "#202020",
    "frame-tracking-2-borderColor": "#333333",
    "frame-tracking-3-fill": "#191919",
    "frame-tracking-3-borderColor": "#333333",
    "frame-tracking-4-fill": "#202020",
    "frame-tracking-5-fill": "#191919",
    "frame-tracking-5-borderColor": "#333333",
    "frame-tracking-6-fill": "#191919",
    "frame-tracking-7-fill": "#121212",
    "frame-tracking-8-fill": "#191919",
    "frame-tracking-9-fill": "#418B5A",
    "frame-tracking-10-fill": "#191919",
    "frame-tracking-10-borderColor": "#333333",
    "frame-tracking-11-fill": "#202020",
    "frame-tracking-11-borderColor": "#333333",
    "frame-tracking-12-fill": "#121212",
    "frame-tracking-12-borderColor": "#333333",
    "frame-tracking-13-fill": "#121212",
    "frame-tracking-14-fill": "#202020",
    "frame-tracking-14-borderColor": "#333333",
    "frame-tracking-15-borderColor": "#333333",
    "frame-tracking-15-fill": "#202020",
    "frame-snackbar-1-fill": "#5DC780",
    "frame-snackbar-2-fill": "#D45858",
    "frame-snackbar-3-fill": "#EEAB5E",
    "frame-upload-1-fill": "#191919",
    "frame-medicine description-1-fill": "#BDB1D8",
    "frame-medicine description-2-fill": "#121212",
    "frame-medicine description-2-borderColor": "#262626",
    "frame-background-1-fill": "#121212",
    "frame-search-1-fill": "#191919",
    "frame-line-1-borderColor": "#262626",
    "frame-popup-1-fill": "#191919",
    "frame-popup-1-borderColor": "#262626",
    "frame-popup-2-fill": "#191919",
    "frame-popup-3-fill": "#191919",
    "frame-prescription-1-fill": "#121212",
    "frame-prescription-3-fill": "#191919",
    "frame-prescription-3-borderColor": "#262626",
    "frame-prescription-6-fill": "#262626",
    "frame-prescription-7-fill": "#191919",
    "frame-prescription-7-borderColor": "#262626",
    "frame-receiver-1-fill": "#121212",
    "frame-receiver-2-fill": "#191919",
    "frame-receiver-3-fill": "#121212",
    "frame-receiver-4-fill": "#191919",
    "frame-receiver-4-borderColor": "#404040",
    "frame-header-1-fill": "#121212",
    "frame-header-1-borderColor": "#262626",
    "frame-bottomsheet-1-fill": "#121212",
    "frame-bottomsheet-2-fill": "#191919",
    "frame-bottomsheet-3-fill": "#191919",
    "bg-100": "#000000",
    "purplecolor-100": "#BDB1D8",
    "fin-100": "#3929F2",
    "quad-40": "#333C66",
    "quad-140": "#B2BFFF",
    "extra-1": "#383138",
    "extra-2": "#BA94C1",
    "extra-3": "#B18CB7",
    "extra-4": "#2A2D22",
    "extra-5": "#7DA889",
    "extra-6": "#89B996",
    "mc-1": "#B992BF",
    "mc-2": "#A885AD",
    "mc-3": "#BB94C1",
    "mc-4": "#C9A5CC",
    "sc-1": "#DC8CA1",
    "sc-2": "#D7748E",
    "sc-3": "#DB7B94",
    "sc-4": "#DD879E",
    "vi-1": "#89B996",
    "vi-2": "#7DA889",
    "vi-3": "#5DC780",
    "vi-4": "#7DD299",
    "pc-1": "#DBCB7D",
    "pc-2": "#BEC081",
    "pc-3": "#675541",
    "pc-4": "#766858",
    "sh-1": "#E59B9B",
    "sh-2": "#BD9494",
    "sh-3": "#DA6464",
    "dc-1": "#BECCC0",
    "dc-2": "#A3B7A6",
    "dc-3": "#6E9074",
    "hc-1": "#666666",
    "hc-2": "#545454",
    "hc-3": "#333333",
    "ec-1": "#DBA47D",
    "ec-2": "#C99773",
    "ec-3": "#EEAB5E",
    "ec-4": "#DBCB7D",
    "notc-1": "#919FDC",
    "notc-2": "#9FAFF3",
  },
  spacing: {
    "cta-entry-field-1-width": "21rem",
    "dynamic-mobile-cta-entry-field-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-entry-field-1-width": "17.5vw",
    "cta-entry-field-1-height": "2.5rem",
    "dynamic-mobile-cta-entry-field-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-entry-field-1-height": "3.7037037037037037vh",
    "cta-entry-field-2-width": "21rem",
    "dynamic-mobile-cta-entry-field-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-entry-field-2-width": "17.5vw",
    "cta-entry-field-2-height": "2.75rem",
    "dynamic-mobile-cta-entry-field-2-height": "6.179775280898877vh",
    "dynamic-desktop-cta-entry-field-2-height": "4.074074074074074vh",
    "cta-typo-1-height": "1.625rem",
    "dynamic-mobile-cta-typo-1-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-1-height": "2.4074074074074074vh",
    "cta-typo-1-width": "4rem",
    "dynamic-mobile-cta-typo-1-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-1-width": "3.3333333333333335vw",
    "cta-typo-2-height": "1.625rem",
    "dynamic-mobile-cta-typo-2-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-2-height": "2.4074074074074074vh",
    "cta-typo-2-width": "5rem",
    "dynamic-mobile-cta-typo-2-width": "22.22222222222222vw",
    "dynamic-desktop-cta-typo-2-width": "4.166666666666667vw",
    "cta-typo-3-height": "1.625rem",
    "dynamic-mobile-cta-typo-3-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-3-height": "2.4074074074074074vh",
    "cta-typo-3-width": "4rem",
    "dynamic-mobile-cta-typo-3-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-3-width": "3.3333333333333335vw",
    "cta-typo-4-height": "1.625rem",
    "dynamic-mobile-cta-typo-4-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-4-height": "2.4074074074074074vh",
    "cta-typo-4-width": "4rem",
    "dynamic-mobile-cta-typo-4-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-4-width": "3.3333333333333335vw",
    "cta-typo-5-height": "1.625rem",
    "dynamic-mobile-cta-typo-5-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-5-height": "2.4074074074074074vh",
    "cta-typo-5-width": "4rem",
    "dynamic-mobile-cta-typo-5-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-5-width": "3.3333333333333335vw",
    "cta-typo-6-height": "1.625rem",
    "dynamic-mobile-cta-typo-6-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-6-height": "2.4074074074074074vh",
    "cta-typo-6-width": "7.875rem",
    "dynamic-mobile-cta-typo-6-width": "35vw",
    "dynamic-desktop-cta-typo-6-width": "6.5625vw",
    "cta-typo-8-height": "1.625rem",
    "dynamic-mobile-cta-typo-8-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-8-height": "2.4074074074074074vh",
    "cta-typo-8-width": "4rem",
    "dynamic-mobile-cta-typo-8-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-8-width": "3.3333333333333335vw",
    "cta-typo-9-height": "1.625rem",
    "dynamic-mobile-cta-typo-9-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typo-9-height": "2.4074074074074074vh",
    "cta-typo-9-width": "4rem",
    "dynamic-mobile-cta-typo-9-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typo-9-width": "3.3333333333333335vw",
    "cta-button-1-width": "5rem",
    "dynamic-mobile-cta-button-1-width": "22.22222222222222vw",
    "dynamic-desktop-cta-button-1-width": "4.166666666666667vw",
    "cta-button-1-height": "2rem",
    "dynamic-mobile-cta-button-1-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-1-height": "2.962962962962963vh",
    "cta-button-2-height": "3.75rem",
    "dynamic-mobile-cta-button-2-height": "8.426966292134832vh",
    "dynamic-desktop-cta-button-2-height": "5.555555555555555vh",
    "cta-button-2-width": "21rem",
    "dynamic-mobile-cta-button-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-2-width": "17.5vw",
    "cta-button-3-height": "2.5rem",
    "dynamic-mobile-cta-button-3-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-3-height": "3.7037037037037037vh",
    "cta-button-3-width": "8.75rem",
    "dynamic-mobile-cta-button-3-width": "38.888888888888886vw",
    "dynamic-desktop-cta-button-3-width": "7.291666666666667vw",
    "cta-button-4-height": "2.5rem",
    "dynamic-mobile-cta-button-4-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-4-height": "3.7037037037037037vh",
    "cta-button-4-width": "10.5rem",
    "dynamic-mobile-cta-button-4-width": "46.666666666666664vw",
    "dynamic-desktop-cta-button-4-width": "8.75vw",
    "cta-button-5-height": "2.75rem",
    "dynamic-mobile-cta-button-5-height": "6.179775280898877vh",
    "dynamic-desktop-cta-button-5-height": "4.074074074074074vh",
    "cta-button-5-width": "6.75rem",
    "dynamic-mobile-cta-button-5-width": "30vw",
    "dynamic-desktop-cta-button-5-width": "5.625vw",
    "cta-button-6-height": "3.75rem",
    "dynamic-mobile-cta-button-6-height": "8.426966292134832vh",
    "dynamic-desktop-cta-button-6-height": "5.555555555555555vh",
    "cta-button-6-width": "21rem",
    "dynamic-mobile-cta-button-6-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-6-width": "17.5vw",
    "cta-button-7-height": "3.75rem",
    "dynamic-mobile-cta-button-7-height": "8.426966292134832vh",
    "dynamic-desktop-cta-button-7-height": "5.555555555555555vh",
    "cta-button-7-width": "21rem",
    "dynamic-mobile-cta-button-7-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-7-width": "17.5vw",
    "cta-button-8-width": "4.75rem",
    "dynamic-mobile-cta-button-8-width": "21.11111111111111vw",
    "dynamic-desktop-cta-button-8-width": "3.9583333333333335vw",
    "cta-button-8-height": "2rem",
    "dynamic-mobile-cta-button-8-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-8-height": "2.962962962962963vh",
    "cta-button-9-height": "2.5rem",
    "dynamic-mobile-cta-button-9-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-9-height": "3.7037037037037037vh",
    "cta-button-9-width": "19.75rem",
    "dynamic-mobile-cta-button-9-width": "87.77777777777777vw",
    "dynamic-desktop-cta-button-9-width": "16.458333333333332vw",
    "cta-button-10-height": "2rem",
    "dynamic-mobile-cta-button-10-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-10-height": "2.962962962962963vh",
    "cta-button-10-width": "11.375rem",
    "dynamic-mobile-cta-button-10-width": "50.55555555555556vw",
    "dynamic-desktop-cta-button-10-width": "9.479166666666666vw",
    "cta-button-11-height": "3.5rem",
    "dynamic-mobile-cta-button-11-height": "7.865168539325842vh",
    "dynamic-desktop-cta-button-11-height": "5.185185185185185vh",
    "cta-button-11-width": "21rem",
    "dynamic-mobile-cta-button-11-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-11-width": "17.5vw",
    "cta-button-12-height": "3.25rem",
    "dynamic-mobile-cta-button-12-height": "7.303370786516854vh",
    "dynamic-desktop-cta-button-12-height": "4.814814814814815vh",
    "cta-button-12-width": "20.5rem",
    "dynamic-mobile-cta-button-12-width": "91.11111111111111vw",
    "dynamic-desktop-cta-button-12-width": "17.083333333333332vw",
    "cta-button-13-height": "3.25rem",
    "dynamic-mobile-cta-button-13-height": "7.303370786516854vh",
    "dynamic-desktop-cta-button-13-height": "4.814814814814815vh",
    "cta-button-13-width": "20.5rem",
    "dynamic-mobile-cta-button-13-width": "91.11111111111111vw",
    "dynamic-desktop-cta-button-13-width": "17.083333333333332vw",
    "cta-button-14-width": "5rem",
    "dynamic-mobile-cta-button-14-width": "22.22222222222222vw",
    "dynamic-desktop-cta-button-14-width": "4.166666666666667vw",
    "cta-button-14-height": "2rem",
    "dynamic-mobile-cta-button-14-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-14-height": "2.962962962962963vh",
    "cta-contact-1-height": "2.75rem",
    "dynamic-mobile-cta-contact-1-height": "6.179775280898877vh",
    "dynamic-desktop-cta-contact-1-height": "4.074074074074074vh",
    "cta-contact-1-width": "6.75rem",
    "dynamic-mobile-cta-contact-1-width": "30vw",
    "dynamic-desktop-cta-contact-1-width": "5.625vw",
    "cta-frame-1-height": "3.125rem",
    "dynamic-mobile-cta-frame-1-height": "7.022471910112359vh",
    "dynamic-desktop-cta-frame-1-height": "4.62962962962963vh",
    "cta-frame-1-width": "21rem",
    "dynamic-mobile-cta-frame-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-frame-1-width": "17.5vw",
    "cta-frame-2-height": "2.5rem",
    "dynamic-mobile-cta-frame-2-height": "5.617977528089888vh",
    "dynamic-desktop-cta-frame-2-height": "3.7037037037037037vh",
    "cta-frame-2-width": "21rem",
    "dynamic-mobile-cta-frame-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-frame-2-width": "17.5vw",
    "cta-frame-3-height": "5.625rem",
    "dynamic-mobile-cta-frame-3-height": "12.640449438202246vh",
    "dynamic-desktop-cta-frame-3-height": "8.333333333333334vh",
    "cta-frame-3-width": "4rem",
    "dynamic-mobile-cta-frame-3-width": "17.77777777777778vw",
    "dynamic-desktop-cta-frame-3-width": "3.3333333333333335vw",
    "cta-frame-4-height": "13rem",
    "dynamic-mobile-cta-frame-4-height": "29.213483146067414vh",
    "dynamic-desktop-cta-frame-4-height": "19.25925925925926vh",
    "cta-frame-4-width": "2.75rem",
    "dynamic-mobile-cta-frame-4-width": "12.222222222222221vw",
    "dynamic-desktop-cta-frame-4-width": "2.2916666666666665vw",
    "cta-checkbox-1-height": "1.125rem",
    "dynamic-mobile-cta-checkbox-1-height": "2.5280898876404496vh",
    "dynamic-desktop-cta-checkbox-1-height": "1.6666666666666667vh",
    "cta-checkbox-1-width": "1.125rem",
    "dynamic-mobile-cta-checkbox-1-width": "5vw",
    "dynamic-desktop-cta-checkbox-1-width": "0.9375vw",
    "cta-hamburger-1-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-1-height": "3.7037037037037037vh",
    "cta-hamburger-1-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-1-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-1-width": "3.8541666666666665vw",
    "cta-hamburger-2-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-2-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-2-height": "3.7037037037037037vh",
    "cta-hamburger-2-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-2-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-2-width": "3.8541666666666665vw",
    "cta-hamburger-3-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-3-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-3-height": "3.7037037037037037vh",
    "cta-hamburger-3-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-3-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-3-width": "3.8541666666666665vw",
    "frame-upload-prescription-1-width": "21rem",
    "dynamic-mobile-frame-upload-prescription-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-upload-prescription-1-width": "17.5vw",
    "frame-upload-prescription-1-height": "7rem",
    "dynamic-mobile-frame-upload-prescription-1-height": "15.730337078651685vh",
    "dynamic-desktop-frame-upload-prescription-1-height": "10.37037037037037vh",
    "frame-listing-1-width": "9.625rem",
    "dynamic-mobile-frame-listing-1-width": "42.77777777777778vw",
    "dynamic-desktop-frame-listing-1-width": "8.020833333333334vw",
    "frame-listing-1-height": "13.5rem",
    "dynamic-mobile-frame-listing-1-height": "30.337078651685392vh",
    "dynamic-desktop-frame-listing-1-height": "20vh",
    "frame-listing-2-width": "9.625rem",
    "dynamic-mobile-frame-listing-2-width": "42.77777777777778vw",
    "dynamic-desktop-frame-listing-2-width": "8.020833333333334vw",
    "frame-listing-2-height": "7.875rem",
    "dynamic-mobile-frame-listing-2-height": "17.696629213483146vh",
    "dynamic-desktop-frame-listing-2-height": "11.666666666666666vh",
    "frame-categories-1-width": "5.875rem",
    "dynamic-mobile-frame-categories-1-width": "26.11111111111111vw",
    "dynamic-desktop-frame-categories-1-width": "4.895833333333333vw",
    "frame-categories-1-height": "11.75rem",
    "dynamic-mobile-frame-categories-1-height": "26.40449438202247vh",
    "dynamic-desktop-frame-categories-1-height": "17.40740740740741vh",
    "frame-categories-2-width": "7.75rem",
    "dynamic-mobile-frame-categories-2-width": "34.44444444444444vw",
    "dynamic-desktop-frame-categories-2-width": "6.458333333333333vw",
    "frame-categories-2-height": "5.875rem",
    "dynamic-mobile-frame-categories-2-height": "13.202247191011235vh",
    "dynamic-desktop-frame-categories-2-height": "8.703703703703704vh",
    "frame-categories-3-width": "19.75rem",
    "dynamic-mobile-frame-categories-3-width": "87.77777777777777vw",
    "dynamic-desktop-frame-categories-3-width": "16.458333333333332vw",
    "frame-categories-3-height": "6rem",
    "dynamic-mobile-frame-categories-3-height": "13.48314606741573vh",
    "dynamic-desktop-frame-categories-3-height": "8.88888888888889vh",
    "frame-categories-4-width": "11.75rem",
    "dynamic-mobile-frame-categories-4-width": "52.22222222222222vw",
    "dynamic-desktop-frame-categories-4-width": "9.791666666666666vw",
    "frame-categories-4-height": "5.875rem",
    "dynamic-mobile-frame-categories-4-height": "13.202247191011235vh",
    "dynamic-desktop-frame-categories-4-height": "8.703703703703704vh",
    "frame-categories-5-width": "7.75rem",
    "dynamic-mobile-frame-categories-5-width": "34.44444444444444vw",
    "dynamic-desktop-frame-categories-5-width": "6.458333333333333vw",
    "frame-categories-5-height": "5.875rem",
    "dynamic-mobile-frame-categories-5-height": "13.202247191011235vh",
    "dynamic-desktop-frame-categories-5-height": "8.703703703703704vh",
    "frame-categories-6-width": "19.75rem",
    "dynamic-mobile-frame-categories-6-width": "87.77777777777777vw",
    "dynamic-desktop-frame-categories-6-width": "16.458333333333332vw",
    "frame-categories-6-height": "6rem",
    "dynamic-mobile-frame-categories-6-height": "13.48314606741573vh",
    "dynamic-desktop-frame-categories-6-height": "8.88888888888889vh",
    "frame-categories-7-width": "7.75rem",
    "dynamic-mobile-frame-categories-7-width": "34.44444444444444vw",
    "dynamic-desktop-frame-categories-7-width": "6.458333333333333vw",
    "frame-categories-7-height": "5.875rem",
    "dynamic-mobile-frame-categories-7-height": "13.202247191011235vh",
    "dynamic-desktop-frame-categories-7-height": "8.703703703703704vh",
    "frame-categories-8-width": "11.75rem",
    "dynamic-mobile-frame-categories-8-width": "52.22222222222222vw",
    "dynamic-desktop-frame-categories-8-width": "9.791666666666666vw",
    "frame-categories-8-height": "5.875rem",
    "dynamic-mobile-frame-categories-8-height": "13.202247191011235vh",
    "dynamic-desktop-frame-categories-8-height": "8.703703703703704vh",
    "frame-categories-9-width": "19.5rem",
    "dynamic-mobile-frame-categories-9-width": "86.66666666666667vw",
    "dynamic-desktop-frame-categories-9-width": "16.25vw",
    "frame-categories-9-height": "6.125rem",
    "dynamic-mobile-frame-categories-9-height": "13.764044943820224vh",
    "dynamic-desktop-frame-categories-9-height": "9.074074074074074vh",
    "frame-entryfield-1-width": "21rem",
    "dynamic-mobile-frame-entryfield-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-entryfield-1-width": "17.5vw",
    "frame-entryfield-1-height": "2.5rem",
    "dynamic-mobile-frame-entryfield-1-height": "5.617977528089888vh",
    "dynamic-desktop-frame-entryfield-1-height": "3.7037037037037037vh",
    "frame-entryfield-2-width": "19.75rem",
    "dynamic-mobile-frame-entryfield-2-width": "87.77777777777777vw",
    "dynamic-desktop-frame-entryfield-2-width": "16.458333333333332vw",
    "frame-entryfield-2-height": "2rem",
    "dynamic-mobile-frame-entryfield-2-height": "4.49438202247191vh",
    "dynamic-desktop-frame-entryfield-2-height": "2.962962962962963vh",
    "frame-entryfield-3-width": "21rem",
    "dynamic-mobile-frame-entryfield-3-width": "93.33333333333333vw",
    "dynamic-desktop-frame-entryfield-3-width": "17.5vw",
    "frame-entryfield-3-height": "2.375rem",
    "dynamic-mobile-frame-entryfield-3-height": "5.337078651685394vh",
    "dynamic-desktop-frame-entryfield-3-height": "3.5185185185185186vh",
    "frame-entryfield-4-width": "6.25rem",
    "dynamic-mobile-frame-entryfield-4-width": "27.77777777777778vw",
    "dynamic-desktop-frame-entryfield-4-width": "5.208333333333333vw",
    "frame-entryfield-4-height": "2.375rem",
    "dynamic-mobile-frame-entryfield-4-height": "5.337078651685394vh",
    "dynamic-desktop-frame-entryfield-4-height": "3.5185185185185186vh",
    "frame-entryfield-5-width": "20rem",
    "dynamic-mobile-frame-entryfield-5-width": "88.88888888888889vw",
    "dynamic-desktop-frame-entryfield-5-width": "16.666666666666668vw",
    "frame-entryfield-5-height": "2.75rem",
    "dynamic-mobile-frame-entryfield-5-height": "6.179775280898877vh",
    "dynamic-desktop-frame-entryfield-5-height": "4.074074074074074vh",
    "frame-dropdown-1-width": "21rem",
    "dynamic-mobile-frame-dropdown-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-dropdown-1-width": "17.5vw",
    "frame-dropdown-2-width": "5.25rem",
    "dynamic-mobile-frame-dropdown-2-width": "23.333333333333332vw",
    "dynamic-desktop-frame-dropdown-2-width": "4.375vw",
    "frame-dropdown-2-height": "2.75rem",
    "dynamic-mobile-frame-dropdown-2-height": "6.179775280898877vh",
    "dynamic-desktop-frame-dropdown-2-height": "4.074074074074074vh",
    "frame-dropdown-3-width": "5.25rem",
    "dynamic-mobile-frame-dropdown-3-width": "23.333333333333332vw",
    "dynamic-desktop-frame-dropdown-3-width": "4.375vw",
    "frame-dropdown-3-height": "2.75rem",
    "dynamic-mobile-frame-dropdown-3-height": "6.179775280898877vh",
    "dynamic-desktop-frame-dropdown-3-height": "4.074074074074074vh",
    "frame-dropdown-4-width": "22.5rem",
    "dynamic-mobile-frame-dropdown-4-width": "100vw",
    "dynamic-desktop-frame-dropdown-4-width": "18.75vw",
    "frame-dropdown-4-height": "3.75rem",
    "dynamic-mobile-frame-dropdown-4-height": "8.426966292134832vh",
    "dynamic-desktop-frame-dropdown-4-height": "5.555555555555555vh",
    "frame-dropdown-5-width": "5.25rem",
    "dynamic-mobile-frame-dropdown-5-width": "23.333333333333332vw",
    "dynamic-desktop-frame-dropdown-5-width": "4.375vw",
    "frame-dropdown-5-height": "2.75rem",
    "dynamic-mobile-frame-dropdown-5-height": "6.179775280898877vh",
    "dynamic-desktop-frame-dropdown-5-height": "4.074074074074074vh",
    "frame-chat-1-height": "4rem",
    "dynamic-mobile-frame-chat-1-height": "8.98876404494382vh",
    "dynamic-desktop-frame-chat-1-height": "5.925925925925926vh",
    "frame-chat-1-width": "22.5rem",
    "dynamic-mobile-frame-chat-1-width": "100vw",
    "dynamic-desktop-frame-chat-1-width": "18.75vw",
    "frame-chat-2-height": "4.625rem",
    "dynamic-mobile-frame-chat-2-height": "10.393258426966293vh",
    "dynamic-desktop-frame-chat-2-height": "6.851851851851852vh",
    "frame-chat-2-width": "22.5rem",
    "dynamic-mobile-frame-chat-2-width": "100vw",
    "dynamic-desktop-frame-chat-2-width": "18.75vw",
    "frame-chat-3-height": "2.75rem",
    "dynamic-mobile-frame-chat-3-height": "6.179775280898877vh",
    "dynamic-desktop-frame-chat-3-height": "4.074074074074074vh",
    "frame-chat-3-width": "2.75rem",
    "dynamic-mobile-frame-chat-3-width": "12.222222222222221vw",
    "dynamic-desktop-frame-chat-3-width": "2.2916666666666665vw",
    "frame-chat-4-height": "2.75rem",
    "dynamic-mobile-frame-chat-4-height": "6.179775280898877vh",
    "dynamic-desktop-frame-chat-4-height": "4.074074074074074vh",
    "frame-chat-4-width": "17.875rem",
    "dynamic-mobile-frame-chat-4-width": "79.44444444444444vw",
    "dynamic-desktop-frame-chat-4-width": "14.895833333333334vw",
    "frame-chat-5-height": "1.125rem",
    "dynamic-mobile-frame-chat-5-height": "2.5280898876404496vh",
    "dynamic-desktop-frame-chat-5-height": "1.6666666666666667vh",
    "frame-chat-6-height": "13rem",
    "dynamic-mobile-frame-chat-6-height": "29.213483146067414vh",
    "dynamic-desktop-frame-chat-6-height": "19.25925925925926vh",
    "frame-chat-6-width": "10.5rem",
    "dynamic-mobile-frame-chat-6-width": "46.666666666666664vw",
    "dynamic-desktop-frame-chat-6-width": "8.75vw",
    "frame-chat-7-height": "9.5rem",
    "dynamic-mobile-frame-chat-7-height": "21.348314606741575vh",
    "dynamic-desktop-frame-chat-7-height": "14.074074074074074vh",
    "frame-chat-7-width": "17.875rem",
    "dynamic-mobile-frame-chat-7-width": "79.44444444444444vw",
    "dynamic-desktop-frame-chat-7-width": "14.895833333333334vw",
    "frame-chat-8-height": "11.375rem",
    "dynamic-mobile-frame-chat-8-height": "25.56179775280899vh",
    "dynamic-desktop-frame-chat-8-height": "16.85185185185185vh",
    "frame-chat-8-width": "22.5rem",
    "dynamic-mobile-frame-chat-8-width": "100vw",
    "dynamic-desktop-frame-chat-8-width": "18.75vw",
    "frame-chat-9-height": "2.75rem",
    "dynamic-mobile-frame-chat-9-height": "6.179775280898877vh",
    "dynamic-desktop-frame-chat-9-height": "4.074074074074074vh",
    "frame-chat-9-width": "5.625rem",
    "dynamic-mobile-frame-chat-9-width": "25vw",
    "dynamic-desktop-frame-chat-9-width": "4.6875vw",
    "frame-payment-1-height": "5.625rem",
    "dynamic-mobile-frame-payment-1-height": "12.640449438202246vh",
    "dynamic-desktop-frame-payment-1-height": "8.333333333333334vh",
    "frame-payment-1-width": "21rem",
    "dynamic-mobile-frame-payment-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-1-width": "17.5vw",
    "frame-payment-2-height": "3.5rem",
    "dynamic-mobile-frame-payment-2-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-2-height": "5.185185185185185vh",
    "frame-payment-2-width": "21rem",
    "dynamic-mobile-frame-payment-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-2-width": "17.5vw",
    "frame-payment-3-height": "3.5rem",
    "dynamic-mobile-frame-payment-3-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-3-height": "5.185185185185185vh",
    "frame-payment-3-width": "21rem",
    "dynamic-mobile-frame-payment-3-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-3-width": "17.5vw",
    "frame-payment-4-height": "3.5rem",
    "dynamic-mobile-frame-payment-4-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-4-height": "5.185185185185185vh",
    "frame-payment-4-width": "21rem",
    "dynamic-mobile-frame-payment-4-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-4-width": "17.5vw",
    "frame-payment-5-height": "3.5rem",
    "dynamic-mobile-frame-payment-5-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-5-height": "5.185185185185185vh",
    "frame-payment-5-width": "21rem",
    "dynamic-mobile-frame-payment-5-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-5-width": "17.5vw",
    "frame-payment-6-height": "7.125rem",
    "dynamic-mobile-frame-payment-6-height": "16.01123595505618vh",
    "dynamic-desktop-frame-payment-6-height": "10.555555555555555vh",
    "frame-payment-6-width": "22.5rem",
    "dynamic-mobile-frame-payment-6-width": "100vw",
    "dynamic-desktop-frame-payment-6-width": "18.75vw",
    "frame-payment-7-height": "3.5rem",
    "dynamic-mobile-frame-payment-7-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-7-height": "5.185185185185185vh",
    "frame-payment-7-width": "21rem",
    "dynamic-mobile-frame-payment-7-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-7-width": "17.5vw",
    "frame-payment-8-height": "3.5rem",
    "dynamic-mobile-frame-payment-8-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-8-height": "5.185185185185185vh",
    "frame-payment-8-width": "21rem",
    "dynamic-mobile-frame-payment-8-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-8-width": "17.5vw",
    "frame-payment-9-height": "3.5rem",
    "dynamic-mobile-frame-payment-9-height": "7.865168539325842vh",
    "dynamic-desktop-frame-payment-9-height": "5.185185185185185vh",
    "frame-payment-9-width": "21rem",
    "dynamic-mobile-frame-payment-9-width": "93.33333333333333vw",
    "dynamic-desktop-frame-payment-9-width": "17.5vw",
    "frame-tracking-1-height": "4rem",
    "dynamic-mobile-frame-tracking-1-height": "8.98876404494382vh",
    "dynamic-desktop-frame-tracking-1-height": "5.925925925925926vh",
    "frame-tracking-1-width": "22.5rem",
    "dynamic-mobile-frame-tracking-1-width": "100vw",
    "dynamic-desktop-frame-tracking-1-width": "18.75vw",
    "frame-tracking-2-height": "10.125rem",
    "dynamic-mobile-frame-tracking-2-height": "22.752808988764045vh",
    "dynamic-desktop-frame-tracking-2-height": "15vh",
    "frame-tracking-2-width": "21rem",
    "dynamic-mobile-frame-tracking-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-2-width": "17.5vw",
    "frame-tracking-3-height": "3.75rem",
    "dynamic-mobile-frame-tracking-3-height": "8.426966292134832vh",
    "dynamic-desktop-frame-tracking-3-height": "5.555555555555555vh",
    "frame-tracking-3-width": "21rem",
    "dynamic-mobile-frame-tracking-3-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-3-width": "17.5vw",
    "frame-tracking-4-height": "4rem",
    "dynamic-mobile-frame-tracking-4-height": "8.98876404494382vh",
    "dynamic-desktop-frame-tracking-4-height": "5.925925925925926vh",
    "frame-tracking-4-width": "21rem",
    "dynamic-mobile-frame-tracking-4-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-4-width": "17.5vw",
    "frame-tracking-5-height": "2rem",
    "dynamic-mobile-frame-tracking-5-height": "4.49438202247191vh",
    "dynamic-desktop-frame-tracking-5-height": "2.962962962962963vh",
    "frame-tracking-5-width": "21rem",
    "dynamic-mobile-frame-tracking-5-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-5-width": "17.5vw",
    "frame-tracking-6-height": "4.25rem",
    "dynamic-mobile-frame-tracking-6-height": "9.55056179775281vh",
    "dynamic-desktop-frame-tracking-6-height": "6.296296296296297vh",
    "frame-tracking-6-width": "21rem",
    "dynamic-mobile-frame-tracking-6-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-6-width": "17.5vw",
    "frame-tracking-7-height": "32.125rem",
    "dynamic-mobile-frame-tracking-7-height": "72.19101123595506vh",
    "dynamic-desktop-frame-tracking-7-height": "47.592592592592595vh",
    "frame-tracking-7-width": "22.5rem",
    "dynamic-mobile-frame-tracking-7-width": "100vw",
    "dynamic-desktop-frame-tracking-7-width": "18.75vw",
    "frame-tracking-8-height": "26.375rem",
    "dynamic-mobile-frame-tracking-8-height": "59.26966292134831vh",
    "dynamic-desktop-frame-tracking-8-height": "39.074074074074076vh",
    "frame-tracking-8-width": "21rem",
    "dynamic-mobile-frame-tracking-8-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-8-width": "17.5vw",
    "frame-tracking-9-height": "17.5rem",
    "dynamic-mobile-frame-tracking-9-height": "39.325842696629216vh",
    "dynamic-desktop-frame-tracking-9-height": "25.925925925925927vh",
    "frame-tracking-9-width": "19.5rem",
    "dynamic-mobile-frame-tracking-9-width": "86.66666666666667vw",
    "dynamic-desktop-frame-tracking-9-width": "16.25vw",
    "frame-tracking-10-height": "13.75rem",
    "dynamic-mobile-frame-tracking-10-height": "30.89887640449438vh",
    "dynamic-desktop-frame-tracking-10-height": "20.37037037037037vh",
    "frame-tracking-10-width": "21rem",
    "dynamic-mobile-frame-tracking-10-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-10-width": "17.5vw",
    "frame-tracking-11-height": "3.875rem",
    "dynamic-mobile-frame-tracking-11-height": "8.707865168539326vh",
    "dynamic-desktop-frame-tracking-11-height": "5.7407407407407405vh",
    "frame-tracking-11-width": "21rem",
    "dynamic-mobile-frame-tracking-11-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-11-width": "17.5vw",
    "frame-tracking-12-height": "4.75rem",
    "dynamic-mobile-frame-tracking-12-height": "10.674157303370787vh",
    "dynamic-desktop-frame-tracking-12-height": "7.037037037037037vh",
    "frame-tracking-12-width": "19.75rem",
    "dynamic-mobile-frame-tracking-12-width": "87.77777777777777vw",
    "dynamic-desktop-frame-tracking-12-width": "16.458333333333332vw",
    "frame-tracking-13-height": "61.125rem",
    "dynamic-mobile-frame-tracking-13-height": "137.35955056179776vh",
    "dynamic-desktop-frame-tracking-13-height": "90.55555555555556vh",
    "frame-tracking-13-width": "22.5rem",
    "dynamic-mobile-frame-tracking-13-width": "100vw",
    "dynamic-desktop-frame-tracking-13-width": "18.75vw",
    "frame-tracking-14-height": "3.875rem",
    "dynamic-mobile-frame-tracking-14-height": "8.707865168539326vh",
    "dynamic-desktop-frame-tracking-14-height": "5.7407407407407405vh",
    "frame-tracking-14-width": "21rem",
    "dynamic-mobile-frame-tracking-14-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-14-width": "17.5vw",
    "frame-tracking-15-height": "3.875rem",
    "dynamic-mobile-frame-tracking-15-height": "8.707865168539326vh",
    "dynamic-desktop-frame-tracking-15-height": "5.7407407407407405vh",
    "frame-tracking-15-width": "21rem",
    "dynamic-mobile-frame-tracking-15-width": "93.33333333333333vw",
    "dynamic-desktop-frame-tracking-15-width": "17.5vw",
    "frame-snackbar-1-height": "2rem",
    "dynamic-mobile-frame-snackbar-1-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-1-height": "2.962962962962963vh",
    "frame-snackbar-1-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-1-width": "100vw",
    "dynamic-desktop-frame-snackbar-1-width": "18.75vw",
    "frame-snackbar-2-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-2-width": "100vw",
    "dynamic-desktop-frame-snackbar-2-width": "18.75vw",
    "frame-snackbar-2-height": "2rem",
    "dynamic-mobile-frame-snackbar-2-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-2-height": "2.962962962962963vh",
    "frame-snackbar-3-height": "2rem",
    "dynamic-mobile-frame-snackbar-3-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-3-height": "2.962962962962963vh",
    "frame-snackbar-3-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-3-width": "100vw",
    "dynamic-desktop-frame-snackbar-3-width": "18.75vw",
    "frame-upload-1-height": "15.5rem",
    "dynamic-mobile-frame-upload-1-height": "34.831460674157306vh",
    "dynamic-desktop-frame-upload-1-height": "22.962962962962962vh",
    "frame-upload-1-width": "22.5rem",
    "dynamic-mobile-frame-upload-1-width": "100vw",
    "dynamic-desktop-frame-upload-1-width": "18.75vw",
    "frame-upload-2-height": "3.5rem",
    "dynamic-mobile-frame-upload-2-height": "7.865168539325842vh",
    "dynamic-desktop-frame-upload-2-height": "5.185185185185185vh",
    "frame-upload-2-width": "3.5rem",
    "dynamic-mobile-frame-upload-2-width": "15.555555555555555vw",
    "dynamic-desktop-frame-upload-2-width": "2.9166666666666665vw",
    "frame-medicine description-1-height": "15rem",
    "dynamic-mobile-frame-medicine description-1-height": "33.70786516853933vh",
    "dynamic-desktop-frame-medicine description-1-height":
      "22.22222222222222vh",
    "frame-medicine description-1-width": "21rem",
    "dynamic-mobile-frame-medicine description-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-medicine description-1-width": "17.5vw",
    "frame-medicine description-2-height": "5rem",
    "dynamic-mobile-frame-medicine description-2-height":
      "11.235955056179776vh",
    "dynamic-desktop-frame-medicine description-2-height":
      "7.407407407407407vh",
    "frame-medicine description-2-width": "22.5rem",
    "dynamic-mobile-frame-medicine description-2-width": "100vw",
    "dynamic-desktop-frame-medicine description-2-width": "18.75vw",
    "frame-background-1-width": "21rem",
    "dynamic-mobile-frame-background-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-background-1-width": "17.5vw",
    "frame-search-1-height": "13.25rem",
    "dynamic-mobile-frame-search-1-height": "29.775280898876403vh",
    "dynamic-desktop-frame-search-1-height": "19.62962962962963vh",
    "frame-search-1-width": "21rem",
    "dynamic-mobile-frame-search-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-search-1-width": "17.5vw",
    "frame-image-1-height": "3.5rem",
    "dynamic-mobile-frame-image-1-height": "7.865168539325842vh",
    "dynamic-desktop-frame-image-1-height": "5.185185185185185vh",
    "frame-image-1-width": "3.5rem",
    "dynamic-mobile-frame-image-1-width": "15.555555555555555vw",
    "dynamic-desktop-frame-image-1-width": "2.9166666666666665vw",
    "frame-line-1-width": "20.5rem",
    "dynamic-mobile-frame-line-1-width": "91.11111111111111vw",
    "dynamic-desktop-frame-line-1-width": "17.083333333333332vw",
    "frame-popup-1-height": "6rem",
    "dynamic-mobile-frame-popup-1-height": "13.48314606741573vh",
    "dynamic-desktop-frame-popup-1-height": "8.88888888888889vh",
    "frame-popup-1-width": "19.75rem",
    "dynamic-mobile-frame-popup-1-width": "87.77777777777777vw",
    "dynamic-desktop-frame-popup-1-width": "16.458333333333332vw",
    "frame-popup-2-height": "15rem",
    "dynamic-mobile-frame-popup-2-height": "33.70786516853933vh",
    "dynamic-desktop-frame-popup-2-height": "22.22222222222222vh",
    "frame-popup-2-width": "18.75rem",
    "dynamic-mobile-frame-popup-2-width": "83.33333333333333vw",
    "dynamic-desktop-frame-popup-2-width": "15.625vw",
    "frame-popup-3-height": "21.25rem",
    "dynamic-mobile-frame-popup-3-height": "47.752808988764045vh",
    "dynamic-desktop-frame-popup-3-height": "31.48148148148148vh",
    "frame-popup-3-width": "22rem",
    "dynamic-mobile-frame-popup-3-width": "97.77777777777777vw",
    "dynamic-desktop-frame-popup-3-width": "18.333333333333332vw",
    "frame-prescription-1-height": "9.375rem",
    "dynamic-mobile-frame-prescription-1-height": "21.06741573033708vh",
    "dynamic-desktop-frame-prescription-1-height": "13.88888888888889vh",
    "frame-prescription-1-width": "21rem",
    "dynamic-mobile-frame-prescription-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-prescription-1-width": "17.5vw",
    "frame-prescription-2-width": "4rem",
    "dynamic-mobile-frame-prescription-2-width": "17.77777777777778vw",
    "dynamic-desktop-frame-prescription-2-width": "3.3333333333333335vw",
    "frame-prescription-2-height": "5.625rem",
    "dynamic-mobile-frame-prescription-2-height": "12.640449438202246vh",
    "dynamic-desktop-frame-prescription-2-height": "8.333333333333334vh",
    "frame-prescription-3-width": "20rem",
    "dynamic-mobile-frame-prescription-3-width": "88.88888888888889vw",
    "dynamic-desktop-frame-prescription-3-width": "16.666666666666668vw",
    "frame-prescription-3-height": "21rem",
    "dynamic-mobile-frame-prescription-3-height": "47.19101123595506vh",
    "dynamic-desktop-frame-prescription-3-height": "31.11111111111111vh",
    "frame-prescription-4-width": "8.75rem",
    "dynamic-mobile-frame-prescription-4-width": "38.888888888888886vw",
    "dynamic-desktop-frame-prescription-4-width": "7.291666666666667vw",
    "frame-prescription-4-height": "13rem",
    "dynamic-mobile-frame-prescription-4-height": "29.213483146067414vh",
    "dynamic-desktop-frame-prescription-4-height": "19.25925925925926vh",
    "frame-prescription-5-width": "2.75rem",
    "dynamic-mobile-frame-prescription-5-width": "12.222222222222221vw",
    "dynamic-desktop-frame-prescription-5-width": "2.2916666666666665vw",
    "frame-prescription-5-height": "13rem",
    "dynamic-mobile-frame-prescription-5-height": "29.213483146067414vh",
    "dynamic-desktop-frame-prescription-5-height": "19.25925925925926vh",
    "frame-prescription-6-width": "20.5rem",
    "dynamic-mobile-frame-prescription-6-width": "91.11111111111111vw",
    "dynamic-desktop-frame-prescription-6-width": "17.083333333333332vw",
    "frame-prescription-7-height": "5rem",
    "dynamic-mobile-frame-prescription-7-height": "11.235955056179776vh",
    "dynamic-desktop-frame-prescription-7-height": "7.407407407407407vh",
    "frame-prescription-7-width": "21rem",
    "dynamic-mobile-frame-prescription-7-width": "93.33333333333333vw",
    "dynamic-desktop-frame-prescription-7-width": "17.5vw",
    "frame-receiver-1-height": "17.5rem",
    "dynamic-mobile-frame-receiver-1-height": "39.325842696629216vh",
    "dynamic-desktop-frame-receiver-1-height": "25.925925925925927vh",
    "frame-receiver-1-width": "22.5rem",
    "dynamic-mobile-frame-receiver-1-width": "100vw",
    "dynamic-desktop-frame-receiver-1-width": "18.75vw",
    "frame-receiver-2-height": "12.25rem",
    "dynamic-mobile-frame-receiver-2-height": "27.528089887640448vh",
    "dynamic-desktop-frame-receiver-2-height": "18.14814814814815vh",
    "frame-receiver-2-width": "21rem",
    "dynamic-mobile-frame-receiver-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-receiver-2-width": "17.5vw",
    "frame-receiver-3-height": "25.875rem",
    "dynamic-mobile-frame-receiver-3-height": "58.146067415730336vh",
    "dynamic-desktop-frame-receiver-3-height": "38.333333333333336vh",
    "frame-receiver-3-width": "22.5rem",
    "dynamic-mobile-frame-receiver-3-width": "100vw",
    "dynamic-desktop-frame-receiver-3-width": "18.75vw",
    "frame-receiver-4-height": "3.5rem",
    "dynamic-mobile-frame-receiver-4-height": "7.865168539325842vh",
    "dynamic-desktop-frame-receiver-4-height": "5.185185185185185vh",
    "frame-receiver-4-width": "21.25rem",
    "dynamic-mobile-frame-receiver-4-width": "94.44444444444444vw",
    "dynamic-desktop-frame-receiver-4-width": "17.708333333333332vw",
    "frame-header-1-height": "4rem",
    "dynamic-mobile-frame-header-1-height": "8.98876404494382vh",
    "dynamic-desktop-frame-header-1-height": "5.925925925925926vh",
    "frame-header-1-width": "22.5rem",
    "dynamic-mobile-frame-header-1-width": "100vw",
    "dynamic-desktop-frame-header-1-width": "18.75vw",
    "frame-bottomsheet-1-height": "36.875rem",
    "dynamic-mobile-frame-bottomsheet-1-height": "82.86516853932584vh",
    "dynamic-desktop-frame-bottomsheet-1-height": "54.629629629629626vh",
    "frame-bottomsheet-1-width": "22.5rem",
    "dynamic-mobile-frame-bottomsheet-1-width": "100vw",
    "dynamic-desktop-frame-bottomsheet-1-width": "18.75vw",
    "frame-bottomsheet-2-height": "15.5rem",
    "dynamic-mobile-frame-bottomsheet-2-height": "34.831460674157306vh",
    "dynamic-desktop-frame-bottomsheet-2-height": "22.962962962962962vh",
    "frame-bottomsheet-2-width": "22.5rem",
    "dynamic-mobile-frame-bottomsheet-2-width": "100vw",
    "dynamic-desktop-frame-bottomsheet-2-width": "18.75vw",
    "frame-bottomsheet-3-height": "24.5rem",
    "dynamic-mobile-frame-bottomsheet-3-height": "55.056179775280896vh",
    "dynamic-desktop-frame-bottomsheet-3-height": "36.2962962962963vh",
    "frame-bottomsheet-3-width": "22.5rem",
    "dynamic-mobile-frame-bottomsheet-3-width": "100vw",
    "dynamic-desktop-frame-bottomsheet-3-width": "18.75vw",
  },
  borderRadius: {
    "cta-entry-field-1-borderRadius": "0.5rem",
    "cta-entry-field-2-borderRadius": "0.5rem",
    "cta-button-1-borderRadius": "0.375rem",
    "cta-button-2-borderRadius": "0.5rem",
    "cta-button-3-borderRadius": "0.375rem",
    "cta-button-4-borderRadius": "0.375rem",
    "cta-button-5-borderRadius": "0.375rem",
    "cta-button-6-borderRadius": "0.5rem",
    "cta-button-7-borderRadius": "0.5rem",
    "cta-button-8-borderRadius": "0.375rem",
    "cta-button-9-borderRadius": "0.25rem",
    "cta-button-10-borderRadius": "0.375rem",
    "cta-button-11-borderRadius": "0.75rem",
    "cta-button-12-borderRadius": "0.5rem",
    "cta-button-13-borderRadius": "0.5rem",
    "cta-button-14-borderRadius": "0.375rem",
    "cta-contact-1-borderRadius": "0.375rem",
    "cta-frame-2-borderRadius": "0.5rem",
    "cta-frame-3-borderRadius": "0.5rem",
    "cta-frame-4-borderRadius": "0.5rem",
    "cta-hamburger-1-borderRadiusTopLeft": "0.375rem",
    "cta-hamburger-1-borderRadiusTopRight": "0.375rem",
    "cta-hamburger-1-borderRadiusBottomRight": "0rem",
    "cta-hamburger-1-borderRadiusBottomLeft": "0rem",
    "cta-hamburger-2-borderRadiusTopLeft": "0rem",
    "cta-hamburger-2-borderRadiusTopRight": "0rem",
    "cta-hamburger-2-borderRadiusBottomRight": "0.375rem",
    "cta-hamburger-2-borderRadiusBottomLeft": "0.375rem",
    "cta-hamburger-3-borderRadiusTopLeft": "0.375rem",
    "cta-hamburger-3-borderRadiusTopRight": "0.375rem",
    "cta-hamburger-3-borderRadiusBottomRight": "0.375rem",
    "cta-hamburger-3-borderRadiusBottomLeft": "0.375rem",
    "frame-upload-prescription-1-borderRadius": "0.5rem",
    "frame-listing-1-borderRadius": "0.5rem",
    "frame-listing-2-borderRadiusTopLeft": "0.5rem",
    "frame-listing-2-borderRadiusTopRight": "0.5rem",
    "frame-listing-2-borderRadiusBottomRight": "0rem",
    "frame-listing-2-borderRadiusBottomLeft": "0rem",
    "frame-categories-1-borderRadius": "0.5rem",
    "frame-categories-2-borderRadius": "0.5rem",
    "frame-categories-3-borderRadius": "0.5rem",
    "frame-categories-4-borderRadius": "0.5rem",
    "frame-categories-5-borderRadius": "0.5rem",
    "frame-categories-6-borderRadius": "0.5rem",
    "frame-categories-7-borderRadius": "0.5rem",
    "frame-categories-8-borderRadius": "0.5rem",
    "frame-categories-9-borderRadius": "0.5rem",
    "frame-entryfield-1-borderRadius": "0.5rem",
    "frame-entryfield-2-borderRadius": "0.375rem",
    "frame-entryfield-3-borderRadius": "0.5rem",
    "frame-entryfield-4-borderRadius": "0.5rem",
    "frame-entryfield-5-borderRadius": "0.5rem",
    "frame-dropdown-1-borderRadius": "0.5rem",
    "frame-dropdown-2-borderRadiusTopLeft": "0.375rem",
    "frame-dropdown-2-borderRadiusTopRight": "0.375rem",
    "frame-dropdown-2-borderRadiusBottomRight": "0rem",
    "frame-dropdown-2-borderRadiusBottomLeft": "0rem",
    "frame-dropdown-3-borderRadiusTopLeft": "0rem",
    "frame-dropdown-3-borderRadiusTopRight": "0rem",
    "frame-dropdown-3-borderRadiusBottomRight": "0.375rem",
    "frame-dropdown-3-borderRadiusBottomLeft": "0.375rem",
    "frame-dropdown-4-borderRadiusTopLeft": "0rem",
    "frame-dropdown-4-borderRadiusTopRight": "0rem",
    "frame-dropdown-4-borderRadiusBottomRight": "1rem",
    "frame-dropdown-4-borderRadiusBottomLeft": "1rem",
    "frame-dropdown-5-borderRadiusTopLeft": "0.375rem",
    "frame-dropdown-5-borderRadiusTopRight": "0.375rem",
    "frame-dropdown-5-borderRadiusBottomRight": "0.375rem",
    "frame-dropdown-5-borderRadiusBottomLeft": "0.375rem",
    "frame-chat-1-borderRadiusBottomLeft": "0.75rem",
    "frame-chat-1-borderRadiusBottomRight": "0.75rem",
    "frame-chat-1-borderRadiusTopRight": "0rem",
    "frame-chat-1-borderRadiusTopLeft": "0rem",
    "frame-chat-2-borderRadiusBottomLeft": "0rem",
    "frame-chat-2-borderRadiusBottomRight": "0rem",
    "frame-chat-2-borderRadiusTopRight": "1.75rem",
    "frame-chat-2-borderRadiusTopLeft": "1.75rem",
    "frame-chat-3-borderRadiusBottomLeft": "1.375rem",
    "frame-chat-3-borderRadiusBottomRight": "1.375rem",
    "frame-chat-3-borderRadiusTopRight": "1.375rem",
    "frame-chat-3-borderRadiusTopLeft": "1.375rem",
    "frame-chat-4-borderRadiusBottomLeft": "1.375rem",
    "frame-chat-4-borderRadiusBottomRight": "1.375rem",
    "frame-chat-4-borderRadiusTopRight": "1.375rem",
    "frame-chat-4-borderRadiusTopLeft": "1.375rem",
    "frame-chat-6-borderRadiusTopLeft": "0.5rem",
    "frame-chat-6-borderRadiusTopRight": "0.0625rem",
    "frame-chat-6-borderRadiusBottomRight": "0.5rem",
    "frame-chat-6-borderRadiusBottomLeft": "0.5rem",
    "frame-chat-7-borderRadiusBottomLeft": "1.375rem",
    "frame-chat-7-borderRadiusBottomRight": "1.375rem",
    "frame-chat-7-borderRadiusTopRight": "1.375rem",
    "frame-chat-7-borderRadiusTopLeft": "1.375rem",
    "frame-chat-8-borderRadiusBottomLeft": "0rem",
    "frame-chat-8-borderRadiusBottomRight": "0rem",
    "frame-chat-8-borderRadiusTopRight": "1.75rem",
    "frame-chat-8-borderRadiusTopLeft": "1.75rem",
    "frame-chat-9-borderRadius": "0.375rem",
    "frame-payment-1-borderRadius": "0.5rem",
    "frame-payment-2-borderRadiusTopLeft": "0.75rem",
    "frame-payment-2-borderRadiusTopRight": "0.75rem",
    "frame-payment-2-borderRadiusBottomRight": "0rem",
    "frame-payment-2-borderRadiusBottomLeft": "0rem",
    "frame-payment-3-borderRadiusBottomRight": "0.75rem",
    "frame-payment-3-borderRadiusTopLeft": "0rem",
    "frame-payment-3-borderRadiusTopRight": "0rem",
    "frame-payment-3-borderRadiusBottomLeft": "0.75rem",
    "frame-payment-4-borderRadiusTopLeft": "0rem",
    "frame-payment-4-borderRadiusTopRight": "0rem",
    "frame-payment-4-borderRadiusBottomRight": "0rem",
    "frame-payment-4-borderRadiusBottomLeft": "0rem",
    "frame-payment-5-borderRadiusTopLeft": "0.75rem",
    "frame-payment-5-borderRadiusTopRight": "0.75rem",
    "frame-payment-5-borderRadiusBottomRight": "0.75rem",
    "frame-payment-5-borderRadiusBottomLeft": "0.75rem",
    "frame-payment-6-borderRadiusBottomLeft": "0rem",
    "frame-payment-6-borderRadiusBottomRight": "0rem",
    "frame-payment-6-borderRadiusTopRight": "1rem",
    "frame-payment-6-borderRadiusTopLeft": "1rem",
    "frame-payment-7-borderRadiusTopLeft": "0.75rem",
    "frame-payment-7-borderRadiusTopRight": "0.75rem",
    "frame-payment-7-borderRadiusBottomRight": "0rem",
    "frame-payment-7-borderRadiusBottomLeft": "0rem",
    "frame-payment-8-borderRadiusTopLeft": "0rem",
    "frame-payment-8-borderRadiusTopRight": "0rem",
    "frame-payment-8-borderRadiusBottomRight": "0rem",
    "frame-payment-8-borderRadiusBottomLeft": "0rem",
    "frame-payment-9-borderRadiusTopLeft": "0rem",
    "frame-payment-9-borderRadiusTopRight": "0rem",
    "frame-payment-9-borderRadiusBottomRight": "0.75rem",
    "frame-payment-9-borderRadiusBottomLeft": "0.75rem",
    "frame-tracking-1-borderRadiusBottomLeft": "1rem",
    "frame-tracking-1-borderRadiusBottomRight": "1rem",
    "frame-tracking-1-borderRadiusTopRight": "0rem",
    "frame-tracking-1-borderRadiusTopLeft": "0rem",
    "frame-tracking-2-borderRadius": "0.75rem",
    "frame-tracking-3-borderRadiusBottomLeft": "0.75rem",
    "frame-tracking-3-borderRadiusBottomRight": "0.75rem",
    "frame-tracking-3-borderRadiusTopRight": "0rem",
    "frame-tracking-3-borderRadiusTopLeft": "0rem",
    "frame-tracking-4-borderRadius": "0.75rem",
    "frame-tracking-5-borderRadiusBottomLeft": "0.75rem",
    "frame-tracking-5-borderRadiusBottomRight": "0.75rem",
    "frame-tracking-5-borderRadiusTopRight": "0rem",
    "frame-tracking-5-borderRadiusTopLeft": "0rem",
    "frame-tracking-6-borderRadius": "0.75rem",
    "frame-tracking-7-borderRadiusBottomLeft": "0rem",
    "frame-tracking-7-borderRadiusBottomRight": "0rem",
    "frame-tracking-7-borderRadiusTopRight": "1rem",
    "frame-tracking-7-borderRadiusTopLeft": "1rem",
    "frame-tracking-8-borderRadius": "0.75rem",
    "frame-tracking-9-borderRadius": "0.375rem",
    "frame-tracking-10-borderRadius": "0.75rem",
    "frame-tracking-11-borderRadiusBottomLeft": "0rem",
    "frame-tracking-11-borderRadiusBottomRight": "0rem",
    "frame-tracking-11-borderRadiusTopRight": "0.75rem",
    "frame-tracking-11-borderRadiusTopLeft": "0.75rem",
    "frame-tracking-12-borderRadius": "0.25rem",
    "frame-tracking-13-borderRadiusTopLeft": "1rem",
    "frame-tracking-13-borderRadiusTopRight": "1rem",
    "frame-tracking-13-borderRadiusBottomRight": "0rem",
    "frame-tracking-13-borderRadiusBottomLeft": "0rem",
    "frame-tracking-14-borderRadius": "0.75rem",
    "frame-tracking-15-borderRadius": "0.75rem",
    "frame-upload-1-borderRadiusTopLeft": "0.75rem",
    "frame-upload-1-borderRadiusTopRight": "0.75rem",
    "frame-upload-1-borderRadiusBottomRight": "0rem",
    "frame-upload-1-borderRadiusBottomLeft": "0rem",
    "frame-upload-2-borderRadius": "0.375rem",
    "frame-medicine description-1-borderRadius": "0.5rem",
    "frame-medicine description-2-borderRadiusTopLeft": "0.5rem",
    "frame-medicine description-2-borderRadiusTopRight": "0.5rem",
    "frame-medicine description-2-borderRadiusBottomRight": "0rem",
    "frame-medicine description-2-borderRadiusBottomLeft": "0rem",
    "frame-background-1-borderRadius": "0.75rem",
    "frame-search-1-borderRadius": "0.75rem",
    "frame-image-1-borderRadius": "0.375rem",
    "frame-popup-1-borderRadius": "0.5rem",
    "frame-popup-2-borderRadius": "0.5rem",
    "frame-popup-3-borderRadiusTopLeft": "0.75rem",
    "frame-popup-3-borderRadiusTopRight": "0.75rem",
    "frame-popup-3-borderRadiusBottomRight": "0rem",
    "frame-popup-3-borderRadiusBottomLeft": "0rem",
    "frame-prescription-1-borderRadius": "0.5rem",
    "frame-prescription-2-borderRadius": "0.5rem",
    "frame-prescription-3-borderRadius": "0.5rem",
    "frame-prescription-4-borderRadius": "0.5rem",
    "frame-prescription-5-borderRadius": "0.5rem",
    "frame-prescription-6-borderRadius": "0.5rem",
    "frame-prescription-7-borderRadius": "0.5rem",
    "frame-receiver-1-borderRadiusTopLeft": "0.75rem",
    "frame-receiver-1-borderRadiusTopRight": "0.75rem",
    "frame-receiver-2-borderRadius": "0.75rem",
    "frame-receiver-3-borderRadiusTopLeft": "0.75rem",
    "frame-receiver-3-borderRadiusTopRight": "0.75rem",
    "frame-receiver-4-borderRadius": "0.5rem",
    "frame-header-1-borderRadiusTopLeft": "0rem",
    "frame-header-1-borderRadiusTopRight": "0rem",
    "frame-header-1-borderRadiusBottomRight": "0.75rem",
    "frame-header-1-borderRadiusBottomLeft": "0.75rem",
    "frame-bottomsheet-1-borderRadiusTopLeft": "1rem",
    "frame-bottomsheet-1-borderRadiusTopRight": "1rem",
    "frame-bottomsheet-1-borderRadiusBottomRight": "0rem",
    "frame-bottomsheet-1-borderRadiusBottomLeft": "0rem",
    "frame-bottomsheet-2-borderRadiusTopLeft": "0.75rem",
    "frame-bottomsheet-2-borderRadiusTopRight": "0.75rem",
    "frame-bottomsheet-2-borderRadiusBottomRight": "0rem",
    "frame-bottomsheet-2-borderRadiusBottomLeft": "0rem",
    "frame-bottomsheet-3-borderRadiusTopLeft": "0.75rem",
    "frame-bottomsheet-3-borderRadiusTopRight": "0.75rem",
    "frame-bottomsheet-3-borderRadiusBottomRight": "0rem",
    "frame-bottomsheet-3-borderRadiusBottomLeft": "0rem",
  },
  borderWidth: {
    "cta-entry-field-1-borderWidth": "0.03125rem",
    "cta-entry-field-2-borderWidth": "0.03125rem",
    "cta-button-5-borderWidth": "0.03125rem",
    "cta-contact-1-borderWidth": "0.03125rem",
    "cta-hamburger-1-borderWidth": "0.03125rem",
    "cta-hamburger-2-borderWidth": "0.03125rem",
    "cta-hamburger-3-borderWidth": "0.03125rem",
    "frame-listing-1-borderWidth": "0.03125rem",
    "frame-entryfield-1-borderWidth": "0.03125rem",
    "frame-entryfield-5-borderWidth": "0.03125rem",
    "frame-dropdown-2-borderWidth": "0.03125rem",
    "frame-dropdown-3-borderWidth": "0.03125rem",
    "frame-dropdown-4-borderWidth": "0.03125rem",
    "frame-dropdown-5-borderWidth": "0.03125rem",
    "frame-chat-1-borderWidthBottom": "0.03125rem",
    "frame-chat-4-borderWidth": "0.03125rem",
    "frame-chat-7-borderWidth": "0.03125rem",
    "frame-chat-9-borderWidth": "0.03125rem",
    "frame-payment-3-borderWidthTop": "0.03125rem",
    "frame-payment-3-borderWidthRight": "0rem",
    "frame-payment-3-borderWidthBottom": "0rem",
    "frame-payment-3-borderWidthLeft": "0rem",
    "frame-payment-4-borderWidthTop": "0.03125rem",
    "frame-payment-4-borderWidthRight": "0rem",
    "frame-payment-4-borderWidthBottom": "0rem",
    "frame-payment-4-borderWidthLeft": "0rem",
    "frame-payment-7-borderWidthTop": "0rem",
    "frame-payment-7-borderWidthRight": "0rem",
    "frame-payment-7-borderWidthBottom": "0rem",
    "frame-payment-7-borderWidthLeft": "0rem",
    "frame-payment-8-borderWidthTop": "0.03125rem",
    "frame-payment-8-borderWidthRight": "0rem",
    "frame-payment-8-borderWidthBottom": "0rem",
    "frame-payment-8-borderWidthLeft": "0rem",
    "frame-payment-9-borderWidthTop": "0.03125rem",
    "frame-payment-9-borderWidthRight": "0rem",
    "frame-payment-9-borderWidthBottom": "0rem",
    "frame-payment-9-borderWidthLeft": "0rem",
    "frame-tracking-1-borderWidthBottom": "0.03125rem",
    "frame-tracking-2-borderWidthBottom": "0.03125rem",
    "frame-tracking-3-borderWidthBottom": "0.03125rem",
    "frame-tracking-5-borderWidthTop": "0.03125rem",
    "frame-tracking-10-borderWidthBottom": "0.03125rem",
    "frame-tracking-11-borderWidthTop": "0.03125rem",
    "frame-tracking-12-borderWidthBottom": "0.03125rem",
    "frame-tracking-15-borderWidth": "0.03125rem",
    "frame-medicine description-2-borderWidthTop": "0.03125rem",
    "frame-line-1-borderWidth": "0.03125rem",
    "frame-popup-1-borderWidth": "0.03125rem",
    "frame-prescription-3-borderWidth": "0.03125rem",
    "frame-prescription-7-borderWidth": "0.03125rem",
    "frame-receiver-4-borderWidth": "0.03125rem",
    "frame-header-1-borderWidthBottom": "0.03125rem",
  },
  opacity: {
    "frame-chat-5-opacity": "30%",
    "frame-popup-2-opacity": "6rem",
    "frame-popup-3-opacity": "6rem",
  },
};

export const medicine_delivery_plugin_components = {
  ".typography-title-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_2": {
    fontFamily: "Gilroy-Medium, sans-serif",
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0.02rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg3_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg4_1": {
    fontFamily: "Gilroy-Bold, sans-serif",
    lineHeight: "inherit",
    fontSize: "2rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg5_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md1_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_1": {
    fontSize: "0.75rem",
    fontWeight: 400,
    fontFamily: "Circular Std, sans-serif",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_8": {
    fontSize: "0.75rem",
    fontWeight: 400,
    fontStyle: "italic",
    fontFamily: "Circular Std, sans-serif",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.01rem",
    textDecoration: "none",
  },
  ".typography-body-md1_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.03rem",
    textDecoration: "none",
  },
  ".typography-body-md1_6": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.8125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.03rem",
    textDecoration: "none",
  },
  ".typography-body-md3_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "underline",
  },
  ".typography-body-md3_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.02rem",
    textDecoration: "none",
  },
  ".typography-body-md3_5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_6": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    textDecoration: "line-through",
    letterSpacing: "0rem",
  },
  ".typography-body-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-discount-sm1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.5rem",
    letterSpacing: "0rem",
    textDecoration: "line-through",
  },
  ".typography-discount-sm1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "line-through",
  },
  ".typography-cta-typo-1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0.03rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "underline",
  },
  ".typography-cta-typo-4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "1rem",
    textDecoration: "none",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.625rem",
    textDecoration: "underline",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-6": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "underline",
  },
  ".typography-cta-typo-8": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.875rem",
    textDecoration: "none",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-9": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.875rem",
    textDecoration: "none",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-10": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".composition-cta-entry-field-1": {
    width: "21rem",
    height: "2.5rem",
    borderRadius: "0.5rem",
    borderColor: "#262626",
    backgroundColor: "#191919",
  },
  ".composition-cta-entry-field-2": {
    width: "21rem",
    height: "2.75rem",
    borderRadius: "0.5rem",
    borderColor: "#262626",
    backgroundColor: "#191919",
  },
  ".composition-cta-typo-1": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-typo-2": {
    height: "1.625rem",
    width: "5rem",
  },
  ".composition-cta-typo-3": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-typo-4": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-typo-5": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-typo-6": {
    height: "1.625rem",
    width: "7.875rem",
  },
  ".composition-cta-typo-8": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-typo-9": {
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-cta-button-1": {
    width: "5rem",
    height: "2rem",
    borderRadius: "0.375rem",
    backgroundColor: "#262D4C",
  },
  ".composition-cta-button-2": {
    height: "3.75rem",
    width: "21rem",
    backgroundColor: "#202020",
    borderRadius: "0.5rem",
  },
  ".composition-cta-button-3": {
    height: "2.5rem",
    width: "8.75rem",
    borderRadius: "0.375rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-button-4": {
    height: "2.5rem",
    width: "10.5rem",
    borderRadius: "0.375rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-button-5": {
    height: "2.75rem",
    width: "6.75rem",
    borderRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-button-6": {
    height: "3.75rem",
    width: "21rem",
    backgroundColor: "#999999",
    borderRadius: "0.5rem",
  },
  ".composition-cta-button-7": {
    height: "3.75rem",
    width: "21rem",
    backgroundColor: "#3929F2",
    borderRadius: "0.5rem",
  },
  ".composition-cta-button-8": {
    width: "4.75rem",
    height: "2rem",
    borderRadius: "0.375rem",
    backgroundColor: "#E5E5E5",
  },
  ".composition-cta-button-9": {
    height: "2.5rem",
    width: "19.75rem",
    borderRadius: "0.25rem",
    backgroundColor: "#418B5A",
  },
  ".composition-cta-button-10": {
    height: "2rem",
    width: "11.375rem",
    borderRadius: "0.375rem",
    backgroundColor: "#E5E5E5",
  },
  ".composition-cta-button-11": {
    height: "3.5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#191919",
  },
  ".composition-cta-button-12": {
    height: "3.25rem",
    width: "20.5rem",
    backgroundColor: "#999999",
    borderRadius: "0.5rem",
  },
  ".composition-cta-button-13": {
    height: "3.25rem",
    width: "20.5rem",
    backgroundColor: "#3929F2",
    borderRadius: "0.5rem",
  },
  ".composition-cta-button-14": {
    width: "5rem",
    height: "2rem",
    borderRadius: "0.375rem",
    backgroundColor: "#D9E0FC",
  },
  ".composition-cta-contact-1": {
    height: "2.75rem",
    width: "6.75rem",
    backgroundColor: "#191919",
    borderRadius: "0.375rem",
    borderColor: "#262626",
  },
  ".composition-cta-frame-1": {
    height: "3.125rem",
    width: "21rem",
    backgroundColor: "#4A9F66",
  },
  ".composition-cta-frame-2": {
    height: "2.5rem",
    width: "21rem",
    backgroundColor: "#121212",
    borderRadius: "0.5rem",
  },
  ".composition-cta-frame-3": {
    height: "5.625rem",
    width: "4rem",
    backgroundColor: "#3F4A80",
    borderRadius: "0.5rem",
  },
  ".composition-cta-frame-4": {
    height: "13rem",
    width: "2.75rem",
    backgroundColor: "#4C4C4C",
    borderRadius: "0.5rem",
  },
  ".composition-cta-checkbox-1": {
    height: "1.125rem",
    width: "1.125rem",
    backgroundColor: "#5DC780",
  },
  ".composition-cta-hamburger-1": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-hamburger-2": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-hamburger-3": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-frame-upload-prescription-1": {
    width: "21rem",
    height: "7rem",
    backgroundColor: "#121212",
    borderRadius: "0.5rem",
  },
  ".composition-frame-listing-1": {
    width: "9.625rem",
    height: "13.5rem",
    borderRadius: "0.5rem",
    borderColor: "#262626",
    backgroundColor: "#191919",
  },
  ".composition-frame-listing-2": {
    width: "9.625rem",
    height: "7.875rem",
    borderTopLeftRadius: "0.5rem",
    borderTopRightRadius: "0.5rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-categories-1": {
    width: "5.875rem",
    height: "11.75rem",
    borderRadius: "0.5rem",
    backgroundColor: "#A1B1F7",
  },
  ".composition-frame-categories-2": {
    width: "7.75rem",
    height: "5.875rem",
    borderRadius: "0.5rem",
    backgroundColor: "#4A9F66",
  },
  ".composition-frame-categories-3": {
    width: "19.75rem",
    height: "6rem",
    borderRadius: "0.5rem",
    backgroundColor: "#EEAB5E",
  },
  ".composition-frame-categories-4": {
    width: "11.75rem",
    height: "5.875rem",
    borderRadius: "0.5rem",
    backgroundColor: "#DB7B94",
  },
  ".composition-frame-categories-5": {
    width: "7.75rem",
    height: "5.875rem",
    borderRadius: "0.5rem",
    backgroundColor: "#5DC780",
  },
  ".composition-frame-categories-6": {
    width: "19.75rem",
    height: "6rem",
    borderRadius: "0.5rem",
    backgroundColor: "#EEAB5E",
  },
  ".composition-frame-categories-7": {
    width: "7.75rem",
    height: "5.875rem",
    borderRadius: "0.5rem",
    backgroundColor: "#BB94C1",
  },
  ".composition-frame-categories-8": {
    width: "11.75rem",
    height: "5.875rem",
    borderRadius: "0.5rem",
    backgroundColor: "#675541",
  },
  ".composition-frame-categories-9": {
    width: "19.5rem",
    height: "6.125rem",
    borderRadius: "0.5rem",
  },
  ".composition-frame-entryfield-1": {
    width: "21rem",
    height: "2.5rem",
    borderRadius: "0.5rem",
    borderColor: "#262626",
    backgroundColor: "#191919",
  },
  ".composition-frame-entryfield-2": {
    width: "19.75rem",
    height: "2rem",
    borderRadius: "0.375rem",
    backgroundColor: "#262626",
  },
  ".composition-frame-entryfield-3": {
    width: "21rem",
    height: "2.375rem",
    borderRadius: "0.5rem",
    backgroundColor: "#262626",
  },
  ".composition-frame-entryfield-4": {
    width: "6.25rem",
    height: "2.375rem",
    borderRadius: "0.5rem",
    backgroundColor: "#262626",
  },
  ".composition-frame-entryfield-5": {
    width: "20rem",
    height: "2.75rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
    borderColor: "#333333",
  },
  ".composition-frame-dropdown-1": {
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-dropdown-2": {
    width: "5.25rem",
    height: "2.75rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    borderColor: "#262626",
  },
  ".composition-frame-dropdown-3": {
    width: "5.25rem",
    height: "2.75rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    borderColor: "#262626",
  },
  ".composition-frame-dropdown-4": {
    width: "22.5rem",
    height: "3.75rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "1rem",
    borderBottomLeftRadius: "1rem",
    borderColor: "#202020",
  },
  ".composition-frame-dropdown-5": {
    width: "5.25rem",
    height: "2.75rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    borderColor: "#262626",
  },
  ".composition-frame-chat-1": {
    height: "4rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderBottomLeftRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
    borderTopRightRadius: "0rem",
    borderTopLeftRadius: "0rem",
    borderColor: "#202020",
    borderBottomWidth: "0.03125rem",
  },
  ".composition-frame-chat-2": {
    height: "4.625rem",
    width: "22.5rem",
    backgroundColor: "#202020",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "1.75rem",
    borderTopLeftRadius: "1.75rem",
  },
  ".composition-frame-chat-3": {
    height: "2.75rem",
    width: "2.75rem",
    backgroundColor: "#333333",
    borderBottomLeftRadius: "1.375rem",
    borderBottomRightRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderTopLeftRadius: "1.375rem",
  },
  ".composition-frame-chat-4": {
    height: "2.75rem",
    width: "17.875rem",
    backgroundColor: "#333333",
    borderBottomLeftRadius: "1.375rem",
    borderBottomRightRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderTopLeftRadius: "1.375rem",
    borderColor: "#4C4C4C",
  },
  ".composition-frame-chat-5": {
    height: "1.125rem",
    backgroundColor: "#FFFFFF",
    opacity: "30%",
  },
  ".composition-frame-chat-6": {
    height: "13rem",
    width: "10.5rem",
    borderTopLeftRadius: "0.5rem",
    borderTopRightRadius: "0.0625rem",
    borderBottomRightRadius: "0.5rem",
    borderBottomLeftRadius: "0.5rem",
  },
  ".composition-frame-chat-7": {
    height: "9.5rem",
    width: "17.875rem",
    backgroundColor: "#333333",
    borderBottomLeftRadius: "1.375rem",
    borderBottomRightRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderTopLeftRadius: "1.375rem",
    borderColor: "#4C4C4C",
  },
  ".composition-frame-chat-8": {
    height: "11.375rem",
    width: "22.5rem",
    backgroundColor: "#202020",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "1.75rem",
    borderTopLeftRadius: "1.75rem",
  },
  ".composition-frame-chat-9": {
    height: "2.75rem",
    width: "5.625rem",
    backgroundColor: "#404040",
    borderColor: "#595959",
    borderRadius: "0.375rem",
  },
  ".composition-frame-payment-1": {
    height: "5.625rem",
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-2": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-3": {
    height: "3.5rem",
    width: "21rem",
    borderBottomRightRadius: "0.75rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderTopWidth: "0.03125rem",
    borderBottomLeftRadius: "0.75rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0rem",
    borderLeftWidth: "0rem",
    backgroundColor: "#121212",
    borderColor: "#262626",
  },
  ".composition-frame-payment-4": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    borderTopWidth: "0.03125rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0rem",
    borderLeftWidth: "0rem",
    borderColor: "#262626",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-5": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-6": {
    height: "7.125rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "1rem",
    borderTopLeftRadius: "1rem",
  },
  ".composition-frame-payment-7": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    borderTopWidth: "0rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0rem",
    borderLeftWidth: "0rem",
    borderColor: "#333333",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-8": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    borderTopWidth: "0.03125rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0rem",
    borderLeftWidth: "0rem",
    borderColor: "#333333",
    backgroundColor: "#121212",
  },
  ".composition-frame-payment-9": {
    height: "3.5rem",
    width: "21rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
    borderTopWidth: "0.03125rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0rem",
    borderLeftWidth: "0rem",
    borderColor: "#333333",
    backgroundColor: "#121212",
  },
  ".composition-frame-tracking-1": {
    height: "4rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderBottomLeftRadius: "1rem",
    borderBottomRightRadius: "1rem",
    borderTopRightRadius: "0rem",
    borderTopLeftRadius: "0rem",
    borderColor: "#202020",
    borderBottomWidth: "0.03125rem",
  },
  ".composition-frame-tracking-2": {
    height: "10.125rem",
    width: "21rem",
    backgroundColor: "#202020",
    borderColor: "#333333",
    borderBottomWidth: "0.03125rem",
    borderRadius: "0.75rem",
  },
  ".composition-frame-tracking-3": {
    height: "3.75rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderBottomLeftRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
    borderTopRightRadius: "0rem",
    borderTopLeftRadius: "0rem",
    borderColor: "#333333",
    borderBottomWidth: "0.03125rem",
  },
  ".composition-frame-tracking-4": {
    height: "4rem",
    width: "21rem",
    backgroundColor: "#202020",
    borderRadius: "0.75rem",
  },
  ".composition-frame-tracking-5": {
    height: "2rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderBottomLeftRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
    borderTopRightRadius: "0rem",
    borderTopLeftRadius: "0rem",
    borderColor: "#333333",
    borderTopWidth: "0.03125rem",
  },
  ".composition-frame-tracking-6": {
    height: "4.25rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
  },
  ".composition-frame-tracking-7": {
    height: "32.125rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "1rem",
    borderTopLeftRadius: "1rem",
  },
  ".composition-frame-tracking-8": {
    height: "26.375rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
  },
  ".composition-frame-tracking-9": {
    height: "17.5rem",
    width: "19.5rem",
    backgroundColor: "#418B5A",
    borderRadius: "0.375rem",
  },
  ".composition-frame-tracking-10": {
    height: "13.75rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderColor: "#333333",
    borderBottomWidth: "0.03125rem",
    borderRadius: "0.75rem",
  },
  ".composition-frame-tracking-11": {
    height: "3.875rem",
    width: "21rem",
    backgroundColor: "#202020",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "0.75rem",
    borderTopLeftRadius: "0.75rem",
    borderColor: "#333333",
    borderTopWidth: "0.03125rem",
  },
  ".composition-frame-tracking-12": {
    height: "4.75rem",
    width: "19.75rem",
    backgroundColor: "#121212",
    borderColor: "#333333",
    borderBottomWidth: "0.03125rem",
    borderRadius: "0.25rem",
  },
  ".composition-frame-tracking-13": {
    height: "61.125rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "1rem",
    borderTopRightRadius: "1rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-tracking-14": {
    height: "3.875rem",
    width: "21rem",
    backgroundColor: "#202020",
    borderRadius: "0.75rem",
    borderColor: "#333333",
  },
  ".composition-frame-tracking-15": {
    height: "3.875rem",
    width: "21rem",
    borderRadius: "0.75rem",
    borderColor: "#333333",
    backgroundColor: "#202020",
  },
  ".composition-frame-snackbar-1": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#5DC780",
  },
  ".composition-frame-snackbar-2": {
    width: "22.5rem",
    height: "2rem",
    backgroundColor: "#D45858",
  },
  ".composition-frame-snackbar-3": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#EEAB5E",
  },
  ".composition-frame-upload-1": {
    height: "15.5rem",
    width: "22.5rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-upload-2": {
    height: "3.5rem",
    width: "3.5rem",
    borderRadius: "0.375rem",
  },
  ".composition-frame-medicine description-1": {
    height: "15rem",
    width: "21rem",
    backgroundColor: "#BDB1D8",
    borderRadius: "0.5rem",
  },
  ".composition-frame-medicine description-2": {
    height: "5rem",
    width: "22.5rem",
    borderTopLeftRadius: "0.5rem",
    borderTopRightRadius: "0.5rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    borderTopWidth: "0.03125rem",
    backgroundColor: "#121212",
    borderColor: "#262626",
  },
  ".composition-frame-background-1": {
    backgroundColor: "#121212",
    borderRadius: "0.75rem",
    width: "21rem",
  },
  ".composition-frame-search-1": {
    height: "13.25rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-image-1": {
    height: "3.5rem",
    width: "3.5rem",
    borderRadius: "0.375rem",
  },
  ".composition-frame-line-1": {
    width: "20.5rem",
    borderColor: "#262626",
  },
  ".composition-frame-popup-1": {
    height: "6rem",
    width: "19.75rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
    borderRadius: "0.5rem",
  },
  ".composition-frame-popup-2": {
    height: "15rem",
    width: "18.75rem",
    backgroundColor: "#191919",
    borderRadius: "0.5rem",
    opacity: "6rem",
    backdropFilter: "blur(1.25rem)",
  },
  ".composition-frame-popup-3": {
    height: "21.25rem",
    width: "22rem",
    backgroundColor: "#191919",
    opacity: "6rem",
    backdropFilter: "blur(1.25rem)",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-prescription-1": {
    height: "9.375rem",
    width: "21rem",
    backgroundColor: "#121212",
    borderRadius: "0.5rem",
  },
  ".composition-frame-prescription-2": {
    width: "4rem",
    height: "5.625rem",
    borderRadius: "0.5rem",
  },
  ".composition-frame-prescription-3": {
    width: "20rem",
    height: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-frame-prescription-4": {
    width: "8.75rem",
    height: "13rem",
    borderRadius: "0.5rem",
  },
  ".composition-frame-prescription-5": {
    width: "2.75rem",
    height: "13rem",
    borderRadius: "0.5rem",
  },
  ".composition-frame-prescription-6": {
    width: "20.5rem",
    backgroundColor: "#262626",
    borderRadius: "0.5rem",
  },
  ".composition-frame-prescription-7": {
    height: "5rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderRadius: "0.5rem",
    borderColor: "#262626",
  },
  ".composition-frame-receiver-1": {
    height: "17.5rem",
    width: "22.5rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-receiver-2": {
    height: "12.25rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
  },
  ".composition-frame-receiver-3": {
    height: "25.875rem",
    width: "22.5rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-receiver-4": {
    height: "3.5rem",
    width: "21.25rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
    borderColor: "#404040",
  },
  ".composition-frame-header-1": {
    height: "4rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
    borderBottomWidth: "0.03125rem",
    borderColor: "#262626",
  },
  ".composition-frame-bottomsheet-1": {
    height: "36.875rem",
    width: "22.5rem",
    borderTopLeftRadius: "1rem",
    borderTopRightRadius: "1rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-bottomsheet-2": {
    height: "15.5rem",
    width: "22.5rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-bottomsheet-3": {
    height: "24.5rem",
    width: "22.5rem",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#191919",
  },
};
